import styled from "styled-components";
import theme from "../../../theme";

export const StyledParagraph = styled.div`
  margin-top: 56px;
  max-width: 809px;
  font-size: 40px;
  line-height: 48px;
  color: ${theme.black};

  @media (max-width: 890px) {
    margin-top: 24px;
    font-size: 35px;
    line-height: 42px;
  }
  @media (max-width: 768px) {
    margin-top: 24px;
    font-size: 30px;
    line-height: 40px;
  }
  @media (max-width: 480px) {
    margin-top: 24px;
    font-size: 24px;
    line-height: 34px;
  }
`;

export const ImageContainer = styled.div`
  cursor: pointer;
  margin-top: 96px;
  margin-bottom: 96px;

  @media (max-width: 890px) {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  @media (max-width: 425px) {
    margin-top: 72px !important;
    margin-bottom: 72px !important;
  }

  a {
    width: 550px;
    height: 100%;
  }

  .blog_img {
    width: 550px;
    height: 528px;
  }

  .gatsby-image-wrapper.gatsby-image-wrapper-constrained {
    max-height: 528px;
  }

  img {
    margin-bottom: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media only screen and (max-width: 767px) {
    .blog_img {
      max-width: 440px !important;
      max-height: 400px !important;
    }
    .gatsby-image-wrapper.gatsby-image-wrapper-constrained {
      max-height: 400px !important;
    }
  }

  @media only screen and (max-width: 480px) {
    .blog_img {
      max-width: 290px !important;
      max-height: 250px !important;
    }
    .gatsby-image-wrapper.gatsby-image-wrapper-constrained {
      max-height: 250px !important;
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
    padding-left: calc((100vw - 1220px) / 2);
    @media (max-width: 1220px) {
      padding-left: 70px;
    }
    @media (max-width: 790px) {
      padding-left: 50px;
    }
    @media (max-width: 480px) {
      padding-left: 20px;
    }
  }

  .swiper-wrapper .swiper-slide:last-child {
    margin-right: 30px;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    line-height: normal;
    width: auto !important;
    max-width: auto;
    max-height: auto;

    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    @media (max-width: 767px) {
      max-width: 440px;
      max-height: auto;
    }

    @media (max-width: 480px) {
      max-width: 290px;
      max-height: auto;
    }
  }
`;

export const LineComponent = styled.div`
  max-width: 100%;
  padding-bottom: 16px;
  margin-top: 16px;
  color: black;

  & :first-child {
    max-width: 65% !important;
    @media (max-width: 767px) {
      max-width: 70% !important;
    }
  }
  span {
    &:first-child {
      float: left;
      text-align: left;
    }
    &:last-child {
      float: right;
      max-width: 30%;
      text-align: right;
    }
  }
  &:after {
    content: "";
    display: block;
    clear: both;
  }

  .category-name-desktop {
    display: block;
  }
  .category-name-mobile {
    display: none;
  }

  @media (max-width: 768px) {
    .category-name-desktop {
      display: none;
    }
    .category-name-mobile {
      display: block;
      margin-right: -110px;
    }
  }
  @media (max-width: 426px) {
    .category-name-mobile {
      display: block;
      margin-right: -50px;
    }
  }
`;